
import { CirclePlusIcon, MinusOnlyIcon, PlusOnlyIcon } from "../../../../../../../../assets/icons";
import styles from "../../FieldTypeModal.module.scss";



type Props = {
    label: String
    onIsLimitChange: (val: boolean) => void
    isLimited: boolean
    value?: number | null
    onNumberChange: (val: number) => void
    stepSize: number
    minVal?: number
    maxVal?: number
    unit?: string
}


export const LimitNumberAttributeFiledConfig = (props: Props) => {

    const increaseValue = () => {
        let val = (props.value || 0) + props.stepSize;
        if (props.maxVal && val > props.maxVal) {
            val = props.maxVal;
        }
        props.onNumberChange(val);
    }
    const decreaseValue = () => {
        let val = (props.value || 0) - props.stepSize;
        if (props.minVal && val < props.minVal) {
            val = props.minVal;
        }
        props.onNumberChange(val);
    }

    return <div className={styles.configurationField}>
        <div className={styles.title}>
            <span className={styles.label}>{props.label}</span>
        </div>
        <div className={styles.body}>
            <div className={styles.LimitNumberDiv}>

                <div className={styles.yesNOdiv}>
                    <div onClick={() => props.onIsLimitChange(true)} className={props.isLimited ? styles.active : ""}>
                        Yes
                    </div>
                    <div onClick={() => props.onIsLimitChange(false)} className={props.isLimited ? "" : styles.active}>
                        No
                    </div>
                </div>
                <div className={`${styles.numberDiv} ${props.isLimited ? "" : styles.disabled}`}>

                    <>
                        <input
                                type="number"
                                value={props.isLimited? props.value || undefined : ''}
                                onChange={(e) => {
                                    let val = Number(e.target.value);
                                    console.log(val)
                                    if (props.maxVal && val > props.maxVal) {
                                        val = props.maxVal;
                                    }
                                    if (props.minVal && val < props.minVal) {
                                        val = props.minVal;
                                    }
                                    props.onNumberChange(val);
                                }}
                                disabled={!props.isLimited}
                            />
                        <div className={`${styles.buttons} ${props.isLimited ? styles.limited : styles.unLimited}`}>
                            {props.unit && <div className={styles.unit}>{props.unit}</div>}
                            <div className={styles.iconBtn} onClick={() => props.isLimited ? increaseValue() : null}>
                                <PlusOnlyIcon />
                            </div>
                            <div className={styles.iconBtn} onClick={() => props.isLimited ? decreaseValue() : null}>
                                <MinusOnlyIcon />
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </div>
    </div>
}